export const CALL_ROLES = {
  OWNER: 'owner',
  CUSTOMER: 'customer'
}
export const CALL_ROLE_MAP = [
  { label: 'Покупатель', value: CALL_ROLES.CUSTOMER },
  { label: 'Собственник', value: CALL_ROLES.OWNER }
]
